import { Component, Input } from "@angular/core";
import { PopoverController } from "@ionic/angular";

@Component({
  selector: "app-popover-list",
  templateUrl: "./popover-list.component.html",
  styleUrls: ["./popover-list.component.scss"],
})
export class PopoverListComponent {
  @Input() data: any[];

  constructor(private popoverController: PopoverController) {}

  /**
   * Dismiss popover
   */
  async dismissPopover() {
    await this.popoverController.dismiss();
  }
}
